// docs: https://github.com/altostra/type-validations#readme
import { anyOf, arrayOf, objectOf } from "@altostra/type-validations";
import { boolean, nullOrUndefined, number, string } from "@altostra/type-validations/lib/primitives";

const maybeNullString = anyOf(nullOrUndefined, string);
const maybeNullBoolean = anyOf(nullOrUndefined, boolean);
const maybeNullNumber = anyOf(nullOrUndefined, number);

const isCustomObjectTypeSchemaFieldApiItem = objectOf({
  name: string,
  display_label: maybeNullString,
  data_type: maybeNullString,
  required: maybeNullBoolean,
  position: maybeNullNumber,
});

export const isRawCustomObjectsTypeNameSchemaFieldsResponse = objectOf({
  items: arrayOf(isCustomObjectTypeSchemaFieldApiItem),
  total_count: number,
  has_more: boolean,
  next_offset: anyOf(nullOrUndefined, number),
  offset: number,
  limit: number,
});

const isCustomObjectsTypeNameSchemaFieldsResultItem = objectOf({
  id: string,
  name: string,
  display_label: string,
  data_type: string,
  required: boolean,
  position: number,
});

export const isCustomObjectsTypeNameSchemaFieldsResult = objectOf({
  hits: number,
  results: arrayOf(isCustomObjectsTypeNameSchemaFieldsResultItem),
});
